<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex flex-column flex-md-row justify-content-between">
                            <!-- Sección Izquierda (Título) -->
                            <div class="col-12 col-md-4 text-center text-md-start">
                                <h6 class="ms-2">Estadísticas de Rentabilidad</h6>
                            </div>
                        </div>
                    </div>
                    <!-- Filtros -->
                    <div class="card-body">
                        <div class="row mb-4">
                            <iframe title="Dashboard - Allo seguimiento Colaboradores" width="800" height="900"
                                src="https://app.powerbi.com/view?r=eyJrIjoiNTM4OGViMjAtMjkyZi00YThlLTk2OTQtZDA1MDJmYmI3NzhkIiwidCI6Ijk5ODQ5MDAwLTZhOGEtNGMyYi04NzcyLWJmMTY0NGE2ODgzNiJ9"
                                frameborder="0" allowFullScreen="true"></iframe>
                        </div>
                        <div class="row mb-4 align-items-end">
                            <div class="col-12 col-md-2 mt-2 text-left">
                                <label for="teams-select">Fecha de Inicio:</label>
                                <input v-model="startDate" type="date" id="start-date" class="form-control">
                            </div>
                            <div class="col-12 col-md-2 mt-2 text-left">
                                <label for="teams-select">Fecha de Fin:</label>
                                <input v-model="endDate" type="date" id="end-date" class="form-control">
                            </div>
                            <div class="col-12 col-md-2 mt-2 text-left">
                                <label for="teams-select">Seleccione:</label>
                                <select class="form-select" id="teams-select" v-model="selectedTeam">
                                    <option value="" disabled selected>Equipo</option>
                                    <option value="">Todos</option>
                                    <option v-for="team in teams" :key="team.team_id" :value="team.team_id">{{ team.team
                                    }}</option>
                                </select>
                            </div>
                            <div class="col-12 col-md-2 mt-2 text-left">
                                <label for="clients-select">Seleccione:</label>
                                <select class="form-select" id="clients-select" v-model="selectedClient"
                                    @change="loadProjects">
                                    <option value="" disabled selected>Cliente</option>
                                    <option value="">Todos</option>
                                    <option v-for="client in clients" :key="client" :value="client.client_id">{{
                                        client.client }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-12 col-md-2 mt-2 text-left">
                                <label for="projects-select">Seleccione:</label>
                                <select class="form-select" id="projects-select" :disabled="!selectedClient"
                                    v-model="selectedProject">
                                    <option value="" disabled selected>Proyecto</option>
                                    <option value="">Todos</option>
                                    <option v-for="project in projects" :key="project" :value="project.project_id">{{
                                        project.project }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-12 col-md-2 mt-2 text-center">
                                <button class="btn btn-warning mb-0 mt-4 w-100" @click="loadData">Cargar Datos</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <div class="row p-4 text-center">
                                    <div>
                                        <b>Datos del {{ formatISODate(startDate) }} al {{ formatISODate(endDate) }}:</b>
                                    </div>
                                </div>
                                <!-- Tarjetas de estadísticas -->
                                <div class="row">
                                    <div class="col-12 col-md-6 mb-2">
                                        <div class="stat">
                                            <h3>Total de Horas</h3>
                                            <p style="color: black">
                                                {{ data.total_hours ? data.total_hours.toFixed(1) : '0.0' }} hrs <br />
                                                <small class="text-muted">
                                                    100%
                                                </small>
                                            </p>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6 mb-2">
                                        <div class="stat">
                                            <h3>Proyectos Clientes</h3>
                                            <p style="color: #5e72e4;">
                                                {{ data.total_billable_hours ? data.total_billable_hours.toFixed(1) :
                                                    '0.0' }} hrs
                                                <br />
                                                <small class="text-muted">
                                                    {{
                                                        data.total_hours && data.total_billable_hours
                                                            ? ((data.total_billable_hours / data.total_hours) * 100).toFixed(1)
                                                            + '%'
                                                            : '0.0%'
                                                    }}
                                                </small>
                                            </p>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6 mb-2">
                                        <div class="stat">
                                            <h3>Proyectos Internos</h3>
                                            <p>
                                                {{ data.total_internal_hours ? data.total_internal_hours.toFixed(1) :
                                                    '0.0' }} hrs
                                                <br />
                                                <small class="text-muted">
                                                    {{
                                                        data.total_hours && data.total_internal_hours
                                                            ? ((data.total_internal_hours / data.total_hours) * 100).toFixed(1)
                                                            + '%'
                                                            : '0.0%'
                                                    }}
                                                </small>
                                            </p>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6 mb-2">
                                        <div class="stat">
                                            <h3>Stand By</h3>
                                            <p style="color: grey;">
                                                {{ data.total_non_billable_hours ?
                                                    data.total_non_billable_hours.toFixed(1) : '0.0' }} hrs
                                                <br />
                                                <small class="text-muted">
                                                    {{
                                                        data.total_hours && data.total_non_billable_hours
                                                            ? ((data.total_non_billable_hours / data.total_hours) *
                                                                100).toFixed(1) + '%'
                                                            : '0.0%'
                                                    }}
                                                </small>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 mb-2">
                                <div class="col-12 col-md-6 mb-2 mt-2 align-self-center">
                                    <!-- Gráfica de Pay -->
                                    <div>
                                        <canvas ref="chart"></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <!-- Tabla de colaboradores participantes en tiempos-->
                            <div class="row p-4 text-center">
                                <div class="col-lg-6 d-flex align-items-center">
                                    <h5>Colaboradores</h5>
                                </div>
                                <div class="col-lg-6 d-flex align-items-center">
                                    <div>
                                        Buscar Colaborador:
                                    </div>
                                    <div class="ms-2">
                                        <input type="text" class="form-control" v-model="searchQuery"
                                            style="width: 300px;">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="table-responsive">
                                    <table class="table table-bordered text-center align-middle">
                                        <thead>
                                            <th>Nombre</th>
                                            <th>Total</th>
                                            <th>P. Clientes</th>
                                            <th>P. Internos</th>
                                            <th>Stand By</th>
                                            <th></th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(user, idx) in filteredUsers" :key="idx">
                                                <td>{{ user.name }}</td>
                                                <td><b>{{ user.total_user_hours ? user.total_user_hours.toFixed(1) :
                                                    '0.0' }} hrs</b></td>
                                                <td>{{ user.user_client_hours ?
                                                    user.user_client_hours.toFixed(1) : '0.0' }} hrs</td>
                                                <td>{{ user.user_internal_hours ?
                                                    user.user_internal_hours.toFixed(1) : '0.0' }} hrs</td>
                                                <td>{{ user.user_standby_hours ?
                                                    user.user_standby_hours.toFixed(1) : '0.0' }} hrs</td>
                                                <td>
                                                    <div class="progress w-100" style="height: 25px;">
                                                        <div class="progress-bar bg-primary" role="progressbar"
                                                            :style="{ width: billablePercent(user) + '%' }"
                                                            :aria-valuenow="billablePercent(user)" aria-valuemin="0"
                                                            aria-valuemax="100">
                                                            {{ billablePercent(user) }}%
                                                        </div>
                                                        <div class="progress-bar bg-secondary" role="progressbar"
                                                            :style="{ width: nonBillablePercent(user) + '%' }"
                                                            :aria-valuenow="nonBillablePercent(user)" aria-valuemin="0"
                                                            aria-valuemax="100">
                                                            {{ nonBillablePercent(user) }}%
                                                        </div>
                                                        <div class="progress-bar" style="background-color: #e85a24;"
                                                            role="progressbar"
                                                            :style="{ width: internalPercent(user) + '%' }"
                                                            :aria-valuenow="internalPercent(user)" aria-valuemin="0"
                                                            aria-valuemax="100">
                                                            {{ internalPercent(user) }}%
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { Chart, registerables } from "chart.js";
import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

Chart.register(...registerables);

// Refs para datos y elementos de la gráfica
const teams = ref([]);
const projects = ref([]);
const clients = ref([]);
const chart = ref(null);
let chartInstance = null;

const endDate = ref(new Date().toISOString().split('T')[0]);

const start = new Date();
start.setMonth(start.getMonth() - 1);
const startDate = ref(start.toISOString().split('T')[0]);

const selectedTeam = ref("")
const selectedClient = ref("");
const selectedProject = ref("")

// Datos de estadísticas
const data = ref({
    total_hours: 0,
    total_billable_hours: 0,
    total_non_billable_hours: 0,
});
const users = ref([])

const searchQuery = ref('')
const filteredUsers = computed(() => {
    const query = searchQuery.value.toLowerCase();
    return users.value.filter(u =>
        (u.name?.toLowerCase().includes(query))
    );
});

const formatISODate = (isoDate) => {
    const [year, month, day] = isoDate.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    let text = date.toLocaleDateString('es-MX', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    }).replace('de ', 'de ').replace(',', ' del');
    return text;
}

const billablePercent = (user) => {
    const total = user.total_user_hours || 0;
    return total > 0 ? Math.round((user.user_client_hours / total) * 100) : 0;
}
const nonBillablePercent = (user) => {
    const total = user.total_user_hours || 0;
    return total > 0 ? Math.round((user.user_standby_hours / total) * 100) : 0;
}
const internalPercent = (user) => {
    const total = user.total_user_hours || 0;
    return total > 0 ? Math.round((user.user_internal_hours / total) * 100) : 0;
}

const loadTeams = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/get-select-teams`, {}, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        teams.value = response.data; // Asigna los datos a variable `teams`
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
};

const loadClients = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/select-clients`, {}, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        clients.value = response.data; // Asigna los datos a variable `clients`
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
};

const loadProjects = async () => {

    if (selectedClient.value) {
        try {
            const response = await axios.post(`${API_BASE_URL}/client-select-projects`, { client_id: selectedClient.value }, {
                headers: {
                    Authorization: `Bearer ${token}`, // Agrega el token en el header
                },
            });
            projects.value = response.data; // Asigna los datos a variable `projects`
        } catch (error) {
            console.error('Error al obtener los datos:', error);
        }
    }

};

const loadData = async () => {

    const body = {
        start_date: startDate.value,
        end_date: endDate.value,
        team_id: selectedTeam.value,
        client_id: selectedClient.value,
        project_id: selectedProject.value
    }
    try {
        const response = await axios.post(`${API_BASE_URL}/billable-time-report-data`, body, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });

        const newData = {
            total_hours: response.data.summary.total_hours,
            total_billable_hours: response.data.summary.clients,
            total_internal_hours: response.data.summary.internal,
            total_non_billable_hours: response.data.summary.stand_by,
        };

        // Actualizamos el objeto de datos
        data.value = newData;
        users.value = response.data.users

        // Actualizamos la gráfica
        renderChart(newData);
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }

};


// Función para renderizar la gráfica
const renderChart = (data) => {
    if (chartInstance) {
        chartInstance.destroy();
    }

    const ctx = chart.value.getContext("2d");
    chartInstance = new Chart(ctx, {
        type: "pie",
        data: {
            labels: ["Clientes", "Internos", "Stand by"],
            datasets: [
                {
                    data: [
                        data.total_billable_hours,
                        data.total_internal_hours,
                        data.total_non_billable_hours,
                    ],
                    backgroundColor: ["#5e72e4", "#e85a24", "#8894ac"],
                },
            ],
        },
    });
};

// Cargar datos cuando el componente se monta
onMounted(() => {
    loadTeams();
    loadClients();
    loadData();
});

</script>
<style scoped>
.chart-container {
    min-width: 400px;
    /* Ancho máximo */
    min-height: 400px;
    /* Alto máximo */
    margin: 0 auto;
}

canvas {
    max-width: 100%;
    max-height: 100%;
}

/* Estilos para los filtros */
.filtros {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
}

.filtros select {
    flex: 1;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #ccc;
}

/* Contenedor principal de estadísticas y gráfica */
.contenido {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

/* Estilos de estadísticas */
.estadisticas {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    flex: 1;
}

.stat {
    background: white;
    padding: 10px;
    border-radius: 6px;
    text-align: center;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.stat h3 {
    margin: 0;
    font-size: 14px;
    color: #333;
}

.stat p {
    margin: 5px 0 0;
    font-size: 18px;
    font-weight: bold;
    color: #fb6340;
}

/* Contenedor de la gráfica */
.chart-container {
    width: 250px;
    height: 250px;
}

canvas {
    max-width: 100%;
    max-height: 100%;
}
</style>